// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-row-striped[data-v-654a76e6]{border-bottom:1.5px solid #d3d3d3}.padding-left-0[data-v-654a76e6]{padding-left:0}.padding-right-0[data-v-654a76e6]{padding-right:0}.panel-heading-notification[data-v-654a76e6]{background-color:#20aea3;padding-top:10px;padding-left:0;padding-bottom:10px;color:#fff}", ""]);
// Exports
module.exports = exports;
